import { supabase } from './supabase'
import { getPageFromSupabase, getAllPagesFromSupabase, savePageToSupabase, deletePageFromSupabase } from './supabaseAdmin';

export interface Page {
  id: string;
  title: string;
  slug: string;
  content: string;
  metaTitle: string;
  metaDescription: string;
  isPublished: boolean;
  isFeatured: boolean;
  template: 'default' | 'landing' | 'article' | 'legal' | 'json';
  author: string;
  publishedAt?: string;
  createdAt: string;
  updatedAt: string;
}

// Initial pages data for development
const initialPages: Page[] = [
  {
    id: '1',
    title: 'Hakkımızda',
    slug: 'hakkimizda',
    content: `<div class="prose prose-slate max-w-none">
      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Kredipark Nedir?</h2>
          <p class="text-slate-600 leading-relaxed">
            Kredipark.com, bankacılık ürünleri karşılaştırma platformudur.
          </p>
        </div>
      </div>

      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Amacımız</h2>
          <p class="text-slate-600 leading-relaxed">
            Kredipark.com'un ana amacı ziyaretçiye en uygun maliyeti olan finansal ürünü, en hızlı şekilde sunarak tasarruf etmesini sağlamaktır.
          </p>
        </div>
      </div>

      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Hizmetlerimiz</h2>
          <p class="text-slate-600 leading-relaxed">
            Kredipark çatısı altında kredi kartı, kredi, mevduat, banka hesap açılışı gibi banka ürünleri müşteri odaklı yaklaşım doğrultusunda birbiri ile karşılaştırılır.
          </p>
          <p class="text-slate-600 leading-relaxed mt-4">
            Karşılaştırma işlemi sonucunda ziyaretçi çeşitli bankaların sunduğu finansal ürünler arasından kendisine en uygun seçimi yaparak başvuru işlemini gerçekleştirir.
          </p>
        </div>
      </div>

      <div class="flex items-start gap-4">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Avantajlar</h2>
          <p class="text-slate-600 leading-relaxed">
            Ziyaretçi Kredipark.com aracılığı ile tüm banka ürünlerini tek bir çatı platform altında karşılaştırma kolaylığına ücretsiz erişim sağlar.
          </p>
        </div>
      </div>
    </div>`,
    metaTitle: 'Hakkımızda - KrediPark',
    metaDescription: 'KrediPark hakkında bilgi edinin. Misyonumuz, vizyonumuz ve değerlerimiz.',
    isPublished: true,
    isFeatured: false,
    template: 'default',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-18T10:00:00Z'
  },
  {
    id: '2',
    title: 'Gizlilik Politikası',
    slug: 'gizlilik-politikasi',
    content: `<div class="prose prose-slate max-w-none space-y-8">
      <div>
        <h2 class="text-2xl font-semibold text-slate-800 mb-4">1. Kişisel Verilerinizin Ne Şekilde İşlenebileceği</h2>
        <p class="text-slate-600 leading-relaxed">
          6698 sayılı KVKK uyarınca, Kredipark.com ile paylaştığınız kişisel verileriniz, tamamen veya kısmen, otomatik olarak veyahut herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilerek, kaydedilerek, depolanarak, değiştirilerek, yeniden düzenlenerek, kısacası veriler üzerinde gerçekleştirilen her türlü işleme konu olarak tarafımızdan işlenebilecektir. KVKK kapsamında veriler üzerinde gerçekleştirilen her türlü işlem "kişisel verilerin işlenmesi" olarak kabul edilmektedir.
        </p>
      </div>
      
      <div>
        <h2 class="text-2xl font-semibold text-slate-800 mb-4">2. Kişisel Verilerinizin İşlenme Amaçları Ve Hukuki Sebepleri</h2>
        <p class="text-slate-600 leading-relaxed">Paylaştığınız kişisel veriler:</p>
        <ul class="list-disc list-inside space-y-2 text-slate-600 mt-4">
          <li>Müşterilerimize verdiğimiz hizmetlerin gereklerini, sözleşmenin ve teknolojinin gereklerine uygun şekilde yapabilmek, sunulan ürün ve hizmetlerimizi geliştirebilmek için;</li>
          <li>Kamu güvenliğine ilişkin hususlarda ve hukuki uyuşmazlıklarda, talep halinde ve mevzuat gereği savcılıklara, mahkemelere ve ilgili kamu görevlilerine bilgi verebilmek için;</li>
          <li>Üyelerimize geniş kapsamda çeşitli imkânlar sunabilmek veya bu imkânları sunabilecek kişi veya kurumlarla yasal çerçevede paylaşabilmek için;</li>
          <li>Reklam tercihlerini analiz etmek için,</li>
        </ul>
        <p class="text-slate-600 mt-4">6698 sayılı KVKK ve ilgili ikincil düzenlemelere uygun olarak işlenecektir.</p>
      </div>
    </div>`,
    metaTitle: 'Gizlilik Politikası - KrediPark',
    metaDescription: 'KrediPark gizlilik politikası ve kişisel verilerin korunması.',
    isPublished: true,
    isFeatured: false,
    template: 'legal',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-15T14:30:00Z'
  },
  {
    id: '3',
    title: 'KVKK Aydınlatma Metni',
    slug: 'kvkk-aydinlatma-metni',
    content: `<div class="prose prose-slate max-w-none">
      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Veri Sorumlusu</h2>
          <p class="text-slate-600 leading-relaxed">
            6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Technoworks Bilgi Teknolojileri A.Ş. olarak, veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan amaçlar kapsamında hukuka ve dürüstlük kurallarına uygun bir şekilde işleyebilir, kaydedebilir, saklayabilir, sınıflandırabilir, güncelleyebilir ve mevzuatın izin verdiği hallerde üçüncü kişilere açıklayabilir/aktarabiliriz.
          </p>
        </div>
      </div>

      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Kişisel Verilerin İşlenme Amacı</h2>
          <p class="text-slate-600 leading-relaxed mb-4">
            Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
          </p>
          <ul class="list-disc list-inside space-y-2 text-slate-600">
            <li>Hizmetlerimizin sunulması ve geliştirilmesi</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            <li>İletişim faaliyetlerinin yürütülmesi</li>
            <li>Müşteri memnuniyetinin sağlanması</li>
          </ul>
        </div>
      </div>
    </div>`,
    metaTitle: 'KVKK Aydınlatma Metni - KrediPark',
    metaDescription: 'KVKK kapsamında kişisel verilerin işlenmesi hakkında bilgilendirme.',
    isPublished: true,
    isFeatured: false,
    template: 'legal',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-10T09:20:00Z'
  },
  {
    id: '4',
    title: 'Çerez Politikası',
    slug: 'cerez-politikasi',
    content: `<div class="prose prose-slate max-w-none">
      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Çerez Nedir?</h2>
          <p class="text-slate-600 leading-relaxed">
            Çerezler, web sitemizi ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza yerleştirilen küçük metin dosyalarıdır. Bu dosyalar sizin web sitemizi daha etkin kullanmanızı sağlar ve tercihlerinizi hatırlamamıza yardımcı olur.
          </p>
        </div>
      </div>

      <div class="flex items-start gap-4 mb-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">Çerez Türleri</h2>
          <p class="text-slate-600 leading-relaxed mb-4">
            Web sitemizde kullanılan çerez türleri:
          </p>
          <ul class="list-disc list-inside space-y-2 text-slate-600">
            <li>Zorunlu Çerezler: Sitemizin temel işlevleri için gereklidir</li>
            <li>Performans Çerezleri: Sitemizin performansını analiz eder</li>
            <li>İşlevsellik Çerezleri: Tercihlerinizi hatırlar</li>
            <li>Hedefleme Çerezleri: Size özel içerik sunar</li>
          </ul>
        </div>
      </div>
    </div>`,
    metaTitle: 'Çerez Politikası - KrediPark',
    metaDescription: 'KrediPark çerez politikası ve çerezlerin kullanımı hakkında bilgilendirme.',
    isPublished: true,
    isFeatured: false,
    template: 'legal',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-05T11:45:00Z'
  },
  {
    id: '5',
    title: 'Kullanıcı Sözleşmesi',
    slug: 'kullanici-sozlesmesi',
    content: `<div class="prose prose-slate max-w-none space-y-8">
      <div class="space-y-8">
        <div>
          <h2 class="text-2xl font-semibold text-slate-800 mb-4">A. Taraflar</h2>
          <p class="text-slate-600 leading-relaxed">
            İşbu Kullanıcı Sözleşmesi (Bundan böyle "Sözleşme" olarak anılacaktır), Türkiye Cumhuriyeti kanunları uyarınca kurulmuş ve mevcudiyetini sürdüren bir anonim şirket olan, 0623193681000001 MERSİS numarası ile İstanbul Ticaret Sicil Müdürlüğüne 418611-5 numarası ile kayıtşı bulunan KREDİPARK ANONİM ŞİRKETİ (Bundan böyle kısaca "KREDİPARK" olarak anılacaktır) ile www.kredipark.com websitesi (Bundan böyle "Website" olarak anılacaktır) kullanıcısı (Bundan böyle "Kullanıcı" olarak anılacaktır) arasında, Kullanıcı'nın Website'yi kullanmasına yönelik olarak ve Website'nin bulunduğu elektronik ortamda Kullanıcı tarafından onaylanması anında düzenlenmiştir. Kullanıcı, Website'ye giriş yaparak Sözleşme'nin tamamını okuduğunu, içeriğini bütünü ile anladığını ve tüm hükümlerini onayladığını kabul ve beyan eder. (KREDİPARK ve Kullanıcı bundan böyle birlikte "Taraflar" olarak anılacaktır.)
          </p>
        </div>
      </div>
    </div>`,
    metaTitle: 'Kullanıcı Sözleşmesi - KrediPark',
    metaDescription: 'KrediPark kullanıcı sözleşmesi ve kullanım koşulları.',
    isPublished: true,
    isFeatured: false,
    template: 'legal',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-03T16:20:00Z'
  },
  {
    id: '6',
    title: 'Ana Sayfa',
    slug: 'anasayfa',
    content: JSON.stringify({
      heroTitle: "Bankaları Karşılaştır, En Uygun Olana Başvur",
      heroSubtitle: "Türkiye'nin en kapsamlı banka ve kredi karşılaştırma platformu",
      banksTitle: "Birlikte Çalıştığımız Bankalar",
      banksSubtitle: "Kredipark.com'da sadece avantajlı teklifler sunan bankaların ürünleri ve teklifleri yer almaktadır.",
      faqTitle: "Sık Sorulan Sorular",
      faqSubtitle: "Kredi başvurusu ve süreçleri hakkında merak ettiğiniz tüm sorular ve cevapları",
      features: [
        {
          title: "En Güncel Oranlar",
          description: "Tüm bankaların güncel faiz oranlarını anlık olarak karşılaştırın"
        },
        {
          title: "Güvenli Başvuru",
          description: "SSL sertifikalı güvenli altyapı ile başvurunuzu hemen yapın"
        },
        {
          title: "Hızlı Sonuç",
          description: "Kredi başvurunuz anında değerlendirilir ve sonuçlandırılır"
        }
      ],
      creditOptions: [
        {
          title: "Kobi Kredisi",
          path: "/kobi-kredisi",
          iconName: "Store"
        },
        {
          title: "İhtiyaç Kredisi",
          path: "/ihtiyac-kredisi",
          iconName: "CreditCard"
        },
        {
          title: "Konut Kredisi",
          path: "/konut-kredisi",
          iconName: "Home"
        },
        {
          title: "Taşıt Kredisi",
          path: "/tasit-kredisi",
          iconName: "Car"
        },
        {
          title: "Mevduat Faizi",
          path: "/mevduat",
          iconName: "Clock"
        },
        {
          title: "Müşteri Ol",
          path: "/uzaktan-musteri-edinimi",
          iconName: "UserRound"
        },
        {
          title: "Kredi Kartları",
          path: "/kredi-kartlari",
          iconName: "CreditCard"
        },
        {
          title: "Ticari Kartlar",
          path: "/kredi-kartlari?type=ticari",
          iconName: "Building2"
        },
        {
          title: "Faizsiz Kredi",
          path: "/ihtiyac-kredisi",
          iconName: "BanknoteIcon"
        }
      ],
      bankLogos: [
        {
          id: "akbank",
          name: "Akbank",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/a80c0972-6830-4dc4-b3bc-e236c7fbb5ea.png"
        },
        {
          id: "garanti",
          name: "Garanti BBVA",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/2c60a02b-d37c-48ce-ad8e-deb4e57bf810.jpg"
        },
        {
          id: "yapikredi",
          name: "Yapı Kredi",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/52f6626d-498d-4e76-8fb5-fd4381a1e0db.png"
        },
        {
          id: "qnb",
          name: "QNB Finansbank",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/d9ae3539-f63d-4295-84e6-08dbe6e2a6d6.png"
        },
        {
          id: "isbankasi",
          name: "İş Bankası",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/3b159da8-fe94-4b12-b9fa-4b9c60495305.png"
        },
        {
          id: "ziraatbankasi",
          name: "Ziraat Bankası",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/2cf1c9fe-fbff-4874-a365-fd63455d078c.png"
        },
        {
          id: "nkolay",
          name: "Nkolay",
          logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/7accd65f-06ae-48b1-875e-6d9827590be6.png"
        }
      ],
      faqs: [
        {
          question: "Kredi başvurusu için hangi belgeler gereklidir?",
          answer: "Kredi başvurusu için temel olarak şu belgeler gereklidir:\n\n• Kimlik belgesi (Nüfus cüzdanı, ehliyet veya pasaport)\n• Gelir belgesi (Maaş bordrosu veya serbest çalışanlar için gelir beyanı)\n• İkametgah belgesi\n• Son 3 aylık banka hesap özeti\n\nBazı bankalar ek belgeler talep edebilir. Başvuru öncesi seçtiğiniz bankanın gereksinimlerini kontrol etmenizi öneririz.",
          category: "Kredi Başvurusu"
        },
        {
          question: "Online kredi başvurusu ne kadar sürede sonuçlanır?",
          answer: "Online kredi başvuruları genellikle çok hızlı değerlendirilir:\n\n• İhtiyaç kredisi: 5-10 dakika\n• Konut kredisi: 24-48 saat\n• Taşıt kredisi: 1-2 saat\n\nBaşvurunuzun hızlı sonuçlanması için tüm belgelerin eksiksiz ve doğru olması önemlidir.",
          category: "Kredi Başvurusu"
        },
        {
          question: "Kredi faiz oranları nasıl belirlenir?",
          answer: "Kredi faiz oranları şu faktörlere göre belirlenir:\n\n• TCMB politika faizi\n• Kredi türü (ihtiyaç, konut, taşıt)\n• Vade süresi\n• Kredi tutarı\n• Müşteri kredi notu\n• Bankanın risk politikaları\n\nKrediPark üzerinden tüm bankaların güncel faiz oranlarını karşılaştırabilirsiniz.",
          category: "Kredi Hesaplama"
        },
        {
          question: "Kredi taksit tutarı nasıl hesaplanır?",
          answer: "Kredi taksit tutarı şu bileşenleri içerir:\n\n• Ana para\n• Faiz tutarı\n• KKDF (Kaynak Kullanımı Destekleme Fonu)\n• BSMV (Banka Sigorta Muamele Vergisi)\n\nKrediPark'ın kredi hesaplama aracı ile farklı vade ve tutarlara göre ödeme planınızı kolayca oluşturabilirsiniz.",
          category: "Kredi Hesaplama"
        },
        {
          question: "Kredi notum düşükse kredi çekebilir miyim?",
          answer: "Düşük kredi notuna sahip kişiler için çeşitli alternatifler mevcuttur:\n\n• Kefil göstererek kredi başvurusu\n• İpotek karşılığı kredi\n• Düşük kredi notlular için özel kredi paketleri\n• Teminatlı kredi seçenekleri\n\nKrediPark, kredi notunuza uygun en avantajlı seçenekleri sunmaktadır.",
          category: "Kredi Notu"
        },
        {
          question: "Kredi notumu nasıl yükseltebilirim?",
          answer: "Kredi notunuzu yükseltmek için uygulayabileceğiniz stratejiler:\n\n• Kredi kartı ve kredi ödemelerinizi zamanında yapın\n• Kredi kartı limitinizin %30'undan fazlasını kullanmayın\n• Gereksiz kredi başvurularından kaçının\n• Düzenli gelir akışınızı koruyun\n• Çeşitli kredi ürünlerini kontrollü kullanın",
          category: "Kredi Notu"
        }
      ],
      newsletter: {
        title: "Fırsatlardan Haberdar Olun",
        subtitle: "En güncel banka kampanyaları, uygun kredi fırsatları ve size özel tekliflerden ilk siz haberdar olun.",
        buttonText: "Fırsatlardan Haberdar Ol",
        successTitle: "Teşekkürler!",
        successMessage: "Başvurunuz başarıyla alındı. En güncel kampanya ve fırsatlardan haberdar olmak için e-posta ve SMS bildirimlerinizi takip edebilirsiniz.",
        emailPlaceholder: "E-posta Adresi",
        phonePlaceholder: "Telefon Numarası",
        kvkkText: "Kişisel verilerimin işlenmesine ilişkin Aydınlatma Metni'ni okudum ve kişisel verilerimin bu kapsamda işlenmesini kabul ediyorum.",
        marketingText: "KrediPark'a özel kampanyalar, avantajlı teklifler ve güncel fırsatlardan e-posta ve SMS yoluyla haberdar olmak istiyorum."
      },
      components: [
        {
          id: "component-1",
          type: "faq",
          title: "Sık Sorulan Sorular",
          order: 1,
          settings: {
            title: "Sık Sorulan Sorular",
            subtitle: "Merak ettiğiniz tüm sorular ve cevapları",
            maxItems: 10,
            showCategories: true
          },
          content: {
            faqs: [
              {
                question: "Kredi başvurusu için hangi belgeler gereklidir?",
                answer: "Kredi başvurusu için temel olarak şu belgeler gereklidir:\n\n• Kimlik belgesi (Nüfus cüzdanı, ehliyet veya pasaport)\n• Gelir belgesi (Maaş bordrosu veya serbest çalışanlar için gelir beyanı)\n• İkametgah belgesi\n• Son 3 aylık banka hesap özeti\n\nBazı bankalar ek belgeler talep edebilir. Başvuru öncesi seçtiğiniz bankanın gereksinimlerini kontrol etmenizi öneririz.",
                category: "Kredi Başvurusu"
              },
              {
                question: "Online kredi başvurusu ne kadar sürede sonuçlanır?",
                answer: "Online kredi başvuruları genellikle çok hızlı değerlendirilir:\n\n• İhtiyaç kredisi: 5-10 dakika\n• Konut kredisi: 24-48 saat\n• Taşıt kredisi: 1-2 saat\n\nBaşvurunuzun hızlı sonuçlanması için tüm belgelerin eksiksiz ve doğru olması önemlidir.",
                category: "Kredi Başvurusu"
              },
              {
                question: "Kredi faiz oranları nasıl belirlenir?",
                answer: "Kredi faiz oranları şu faktörlere göre belirlenir:\n\n• TCMB politika faizi\n• Kredi türü (ihtiyaç, konut, taşıt)\n• Vade süresi\n• Kredi tutarı\n• Müşteri kredi notu\n• Bankanın risk politikaları\n\nKrediPark üzerinden tüm bankaların güncel faiz oranlarını karşılaştırabilirsiniz.",
                category: "Kredi Hesaplama"
              }
            ]
          }
        },
        {
          id: "component-2",
          type: "bankList",
          title: "Banka Listesi",
          order: 2,
          settings: {
            title: "Birlikte Çalıştığımız Bankalar",
            subtitle: "Kredipark.com'da sadece avantajlı teklifler sunan bankaların ürünleri ve teklifleri yer almaktadır.",
            autoScroll: true,
            showNames: true
          },
          content: {
            bankLogos: [
              {
                id: "akbank",
                name: "Akbank",
                logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/a80c0972-6830-4dc4-b3bc-e236c7fbb5ea.png"
              },
              {
                id: "garanti",
                name: "Garanti BBVA",
                logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/2c60a02b-d37c-48ce-ad8e-deb4e57bf810.jpg"
              },
              {
                id: "yapikredi",
                name: "Yapı Kredi",
                logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/52f6626d-498d-4e76-8fb5-fd4381a1e0db.png"
              },
              {
                id: "qnb",
                name: "QNB Finansbank",
                logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/d9ae3539-f63d-4295-84e6-08dbe6e2a6d6.png"
              },
              {
                id: "isbankasi",
                name: "İş Bankası",
                logo: "https://cdn.hangikredi.com/images/bankdigitalonboarding/3b159da8-fe94-4b12-b9fa-4b9c60495305.png"
              }
            ]
          }
        },
        {
          id: "component-3",
          type: "newsletter",
          title: "Bülten Kaydı",
          order: 3,
          settings: {
            title: "Fırsatlardan Haberdar Olun",
            subtitle: "En güncel banka kampanyaları, uygun kredi fırsatları ve size özel tekliflerden ilk siz haberdar olun.",
            buttonText: "Fırsatlardan Haberdar Ol",
            successTitle: "Teşekkürler!",
            successMessage: "Başvurunuz başarıyla alındı. En güncel kampanya ve fırsatlardan haberdar olmak için e-posta ve SMS bildirimlerinizi takip edebilirsiniz.",
            emailPlaceholder: "E-posta Adresi",
            phonePlaceholder: "Telefon Numarası",
            kvkkText: "Kişisel verilerimin işlenmesine ilişkin Aydınlatma Metni'ni okudum ve kişisel verilerimin bu kapsamda işlenmesini kabul ediyorum.",
            marketingText: "KrediPark'a özel kampanyalar, avantajlı teklifler ve güncel fırsatlardan e-posta ve SMS yoluyla haberdar olmak istiyorum.",
            showPhone: true,
            showEmail: true
          }
        }
      ]
    }, null, 2),
    metaTitle: 'KrediPark - Kredi ve Banka Karşılaştırma',
    metaDescription: 'Türkiye\'nin en kapsamlı kredi ve banka karşılaştırma platformu. En uygun kredi ve kredi kartı tekliflerini karşılaştırın, size en uygun olanı seçin.',
    isPublished: true,
    isFeatured: true,
    template: 'json',
    author: 'Admin',
    publishedAt: '2024-01-01T00:00:00Z',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  }
];

// Initialize localStorage with initial pages if not already set
const initializeLocalStorage = () => {
  if (typeof window !== 'undefined') {
    const storedPages = localStorage.getItem('kredipark_pages');
    if (!storedPages) {
      localStorage.setItem('kredipark_pages', JSON.stringify(initialPages));
    }
  }
};

// Get pages from localStorage
const getPagesFromStorage = (): Page[] => {
  if (typeof window !== 'undefined') {
    const storedPages = localStorage.getItem('kredipark_pages');
    return storedPages ? JSON.parse(storedPages) : initialPages;
  }
  return initialPages;
};

// Save pages to localStorage
const savePagesToStorage = (pages: Page[]) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('kredipark_pages', JSON.stringify(pages));
  }
};

// Initialize localStorage
initializeLocalStorage();

// Get all pages
export const getAllPages = async (): Promise<Page[]> => {
  try {
    // Try to fetch from Supabase first
    const supabasePages = await getAllPagesFromSupabase();
    
    if (supabasePages && supabasePages.length > 0) {
      // Map Supabase data to our Page interface
      const mappedPages = supabasePages.map(page => ({
        id: page.id,
        title: page.title,
        slug: page.slug,
        content: page.content,
        metaTitle: page.meta_title,
        metaDescription: page.meta_description,
        isPublished: page.is_published,
        isFeatured: page.is_featured,
        template: page.template as 'default' | 'landing' | 'article' | 'legal' | 'json',
        author: page.author,
        publishedAt: page.published_at,
        createdAt: page.created_at,
        updatedAt: page.updated_at
      }));
      
      return mappedPages;
    }
    
    // Fallback to localStorage if Supabase fails or returns no data
    return getPagesFromStorage();
  } catch (error) {
    console.error('Error fetching pages:', error);
    // Fallback to localStorage
    return getPagesFromStorage();
  }
};

// Get page by slug
export const getPageBySlug = async (slug: string): Promise<Page | null> => {
  try {
    // Try to fetch from Supabase first
    const supabasePage = await getPageFromSupabase(slug);
    
    if (supabasePage) {
      // Map Supabase data to our Page interface
      return {
        id: supabasePage.id,
        title: supabasePage.title,
        slug: supabasePage.slug,
        content: supabasePage.content,
        metaTitle: supabasePage.meta_title,
        metaDescription: supabasePage.meta_description,
        isPublished: supabasePage.is_published,
        isFeatured: supabasePage.is_featured,
        template: supabasePage.template as 'default' | 'landing' | 'article' | 'legal' | 'json',
        author: supabasePage.author,
        publishedAt: supabasePage.published_at,
        createdAt: supabasePage.created_at,
        updatedAt: supabasePage.updated_at
      };
    }
    
    // Fallback to localStorage if Supabase fails or returns no data
    const pages = getPagesFromStorage();
    const page = pages.find(p => p.slug === slug);
    return page || null;
  } catch (error) {
    console.error(`Error fetching page with slug ${slug}:`, error);
    // Fallback to localStorage
    const pages = getPagesFromStorage();
    const page = pages.find(p => p.slug === slug);
    return page || null;
  }
};

// Create or update page
export const savePageContent = async (page: Partial<Page>): Promise<Page | null> => {
  try {
    console.log('Saving page:', page);
    
    // Validate required fields
    if (!page.title) {
      console.error('Page title is required');
      return null;
    }
    
    if (!page.slug) {
      console.error('Page slug is required');
      return null;
    }
    
    // Map our Page interface to Supabase format
    const supabasePage = {
      id: page.id,
      title: page.title || '',
      slug: page.slug || '',
      content: page.content || '',
      meta_title: page.metaTitle || '',
      meta_description: page.metaDescription || '',
      is_published: page.isPublished || false,
      is_featured: page.isFeatured || false,
      template: page.template || 'default',
      author: page.author || 'Admin',
      published_at: page.isPublished && !page.publishedAt ? new Date().toISOString() : page.publishedAt,
      updated_at: new Date().toISOString()
    };
    
    // Try to save to Supabase first
    const savedPage = await savePageToSupabase(supabasePage);
    
    if (savedPage) {
      console.log('Page saved to Supabase:', savedPage);
      // Map Supabase response back to our Page interface
      return {
        id: savedPage.id,
        title: savedPage.title,
        slug: savedPage.slug,
        content: savedPage.content,
        metaTitle: savedPage.meta_title,
        metaDescription: savedPage.meta_description,
        isPublished: savedPage.is_published,
        isFeatured: savedPage.is_featured,
        template: savedPage.template as 'default' | 'landing' | 'article' | 'legal' | 'json',
        author: savedPage.author,
        publishedAt: savedPage.published_at,
        createdAt: savedPage.created_at,
        updatedAt: savedPage.updated_at
      };
    }
    
    // Fallback to localStorage if Supabase fails
    const pages = getPagesFromStorage();
    
    if (page.id) {
      // Update existing page
      const index = pages.findIndex(p => p.id === page.id);
      if (index !== -1) {
        pages[index] = {
          ...pages[index],
          ...page,
          updatedAt: new Date().toISOString()
        };
        
        if (page.isPublished && !pages[index].publishedAt) {
          pages[index].publishedAt = new Date().toISOString();
        }
        
        savePagesToStorage(pages);
        return pages[index];
      }
    } else {
      // Create new page
      const newPage: Page = {
        id: Date.now().toString(),
        title: page.title || '',
        slug: page.slug || '',
        content: page.content || '',
        metaTitle: page.metaTitle || '',
        metaDescription: page.metaDescription || '',
        isPublished: page.isPublished || false,
        isFeatured: page.isFeatured || false,
        template: page.template || 'default',
        author: page.author || 'Admin',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      if (newPage.isPublished) {
        newPage.publishedAt = new Date().toISOString();
      }
      
      pages.push(newPage);
      savePagesToStorage(pages);
      return newPage;
    }
    
    return null;
  } catch (error) {
    console.error('Error saving page:', error);
    
    // Fallback to localStorage
    try {
      const pages = getPagesFromStorage();
      
      if (page.id) {
        // Update existing page
        const index = pages.findIndex(p => p.id === page.id);
        if (index !== -1) {
          pages[index] = {
            ...pages[index],
            ...page,
            updatedAt: new Date().toISOString()
          };
          
          if (page.isPublished && !pages[index].publishedAt) {
            pages[index].publishedAt = new Date().toISOString();
          }
          
          savePagesToStorage(pages);
          return pages[index];
        }
      } else {
        // Create new page
        const newPage: Page = {
          id: Date.now().toString(),
          title: page.title || '',
          slug: page.slug || '',
          content: page.content || '',
          metaTitle: page.metaTitle || '',
          metaDescription: page.metaDescription || '',
          isPublished: page.isPublished || false,
          isFeatured: page.isFeatured || false,
          template: page.template || 'default',
          author: page.author || 'Admin',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };
        
        if (newPage.isPublished) {
          newPage.publishedAt = new Date().toISOString();
        }
        
        pages.push(newPage);
        savePagesToStorage(pages);
        return newPage;
      }
    } catch (storageError) {
      console.error('Error saving to localStorage:', storageError);
    }
    
    return null;
  }
};

// Delete page
export const deletePage = async (id: string): Promise<boolean> => {
  try {
    // Try to delete from Supabase first
    const success = await deletePageFromSupabase(id);
    
    if (success) {
      return true;
    }
    
    // Fallback to localStorage if Supabase fails
    const pages = getPagesFromStorage();
    const filteredPages = pages.filter(p => p.id !== id);
    savePagesToStorage(filteredPages);
    return true;
  } catch (error) {
    console.error(`Error deleting page with id ${id}:`, error);
    
    // Fallback to localStorage
    try {
      const pages = getPagesFromStorage();
      const filteredPages = pages.filter(p => p.id !== id);
      savePagesToStorage(filteredPages);
      return true;
    } catch (storageError) {
      console.error('Error deleting from localStorage:', storageError);
      return false;
    }
  }
};

// Get page components
export const getPageComponents = async (slug: string) => {
  try {
    const page = await getPageBySlug(slug);
    if (!page) return [];
    
    // Parse content to get components
    try {
      let content;
      if (typeof page.content === 'string') {
        content = JSON.parse(page.content);
      } else {
        content = page.content;
      }
      
      return content.components || [];
    } catch (error) {
      console.error('Error parsing page content:', error);
      return [];
    }
  } catch (error) {
    console.error('Error getting page components:', error);
    return [];
  }
};